// projects/humanresources-personnel/src/assets/i18n/*/hr-per-address.json
export class HrPerAddressKey {
    private static readonly keyPrefix = 'hrPerAddress';
    public static title = `${HrPerAddressKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerAddressKey.keyPrefix}.pageHeader`;
    public static subDistrict = `${HrPerAddressKey.keyPrefix}.subDistrict`;
    public static mainStreet = `${HrPerAddressKey.keyPrefix}.mainStreet`;
    public static street = `${HrPerAddressKey.keyPrefix}.street`;
    public static complex = `${HrPerAddressKey.keyPrefix}.complex`;
    public static companyName = `${HrPerAddressKey.keyPrefix}.companyName`;
    public static boulevard = `${HrPerAddressKey.keyPrefix}.boulevard`;
    public static village = `${HrPerAddressKey.keyPrefix}.village`;
    public static township = `${HrPerAddressKey.keyPrefix}.township`;
    public static building = `${HrPerAddressKey.keyPrefix}.building`;
    public static buildingNumber = `${HrPerAddressKey.keyPrefix}.buildingNumber`;
    public static floor = `${HrPerAddressKey.keyPrefix}.floor`;
    public static doorNumber = `${HrPerAddressKey.keyPrefix}.doorNumber`;
    public static freeText = `${HrPerAddressKey.keyPrefix}.freeText`;
    public static mernisNumber = `${HrPerAddressKey.keyPrefix}.mernisNumber`;
    public static housingType = `${HrPerAddressKey.keyPrefix}.housingType`;
}
